import BasicList from 'core/modules/components/lists/components/BasicList/BasicList';
import React from 'react';
import NextEventItem from 'core/modules/components/lists/next-events/NextEventItem/NextEventItem';

/**
 * NextEventsList - Lista de próximos eventos. Envuelve el genérico v2 `BasicList`
 * (semántica `<ul>/<li>` accesible) y clona el item recibido con los datos de cada evento.
 */

export type NextEvent = Readonly<{
  name?: string;
  start?: string | Date;
  detail?: string;
  description?: string;
  type?: string;
}>;

type NextEventsListProps = Readonly<{
  events?: NextEvent[];
  itemComponent?: React.ReactElement;
  onClickView?: (event: NextEvent) => void;
  typeView?: string;
}>;

function NextEventsList({
  events = [],
  itemComponent = <NextEventItem />,
  onClickView = () => {},
  typeView,
}: NextEventsListProps): JSX.Element {
  return (
    <div className="next-events-list">
      <BasicList
        items={events.map((item) =>
          React.cloneElement(itemComponent, {
            ...item,
            onClickView: () => onClickView(item),
            typeView,
          })
        )}
      />
    </div>
  );
}

export default NextEventsList;
